<template>
  <v-app-bar
    class="sticky-top app-bar"
    color="#d9753b"
    dense
    dark>
      <v-btn
        v-if="title !== $t('dashboard.title')"
        icon
        @click="goBack()">
        <v-icon>{{ left_navigation_icon }}</v-icon>
      </v-btn>
      <v-btn
        v-else
        icon
        @click="goSearch()">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <SideBar />
  </v-app-bar>
</template>

<script>
import SideBar from "@/components/sidebar/SideBar.vue"

export default {
  name: "AppBar",
  components: {
    SideBar
  },
  props: {
    title: String
  },
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      const pid = this.$store.getters.getCurrentPID
      if (pid !== null) {
        this.$store.commit('setCurrentProcess', null)
        this.$store.commit('setCurrentTaskDefinitionKey', null)
        this.$router.push({ name: 'dashboard'})
      } else {
        window.history.back();
      }
    },
    onRouterLinkClick() {
      const currentTDK = this.$store.getters.getCurrentTDK
      console.log('TDK: %s, isProcessFlow: %s', currentTDK, this.isProcessFlow)
      if (currentTDK !== null && this.isProcessFlow) {
        this.$store.commit('setCurrentTaskDefinitionKey', null)
        this.$store.commit('setCurrentProcess', null)
      }
    },
    goSearch() {
      this.$router.push({ name: 'search'})
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    },
    
  },
  computed: {
    isProcessFlow: function () {
      return this.$store.getters.getCurrentTDK !== null
    },

    left_navigation_icon: function(){
      if (this.$store.getters.getCurrentPID !== null)
      {
        return "mdi-home"
      } else {
        return "mdi-arrow-left"
      }
    }
  }
}
</script>

<style>
.app-bar {
  z-index: 5;
}

.v-toolbar__content {
  padding-left: 0;
  padding-right: 0;
}
</style>